import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const LitigationAssistantWrapper = lazyRoute(
  () => import('features/LitigationAssistant/components/LitigationAssistant'),
  m => m.LitigationAssistantWrapper,
);

export const litigationAssistantRoutes: RouteObject[] = [
  { path: `${PATHNAMES.litigationAssistant}/:id`, lazy: LitigationAssistantWrapper },
];
